import React from 'react';
import { StoreWrap, config as _c, Block, app, api, use } from 'xadmin'
import { C } from 'xadmin-ui'
import LogoComponent from './LogoComponent';
import _ from 'lodash'

const Logout = props => {
  const { type } = props
  const [dashboard, setDashboard] = React.useState()

  React.useEffect(() => {
    if (type == 'front') {
      api({ name: 'core/auth/login/dashboard' })
        .fetch('', {})
        .then(({ json }) => {
          let rectption_logout_page = _c('isMobile') ? json?.mobilePage?.rectption_logout_page : (json?.rectption_logout_page || json?.customPage?.rectption_logout_page)
          rectption_logout_page && setDashboard(rectption_logout_page)
        })

    }
  }, [type])

  React.useEffect(() => {

    if (!dashboard?.id) {
      setTimeout(() => {
        if (window.location.pathname !== '/logout') {
          window.location.href = window.location.pathname
        } else {
          window.location.href = '/login'
        }
      }, 2000)
    }

  }, [dashboard])

  return (
    <>
      {
        !_.isEmpty(dashboard) && type == 'front' ?
          <C is="DashboardView" item={dashboard}>
            <C is="DashboardNormalView" />
          </C> :
          <div className="setGuideCard">
            <div className="guideContent" style={{ width: '648px', margin: '0 auto', borderRadius: '5px' }}>
              <div style={{ maxWidth: '688px', background: 'rgba(255,255,255,.1)', padding: '28px' }}>
                <div style={{ maxWidth: '648px', background: 'rgba(255,255,255,.26)', padding: '28px' }}>
                  <div className="loginGuide" >
                    <div className="loginBox">
                      <LogoComponent></LogoComponent>
                    </div>
                    <div style={{ textAlign: 'center' }}>您已经安全退出系统，两秒后自动跳转到登录页。</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
      }
    </>
  )
}

export default Logout
